import { globalStyle, style } from '@vanilla-extract/css';

import { embla } from '../components/EmblaCarousel/embla.css';

export const rssFeedGrid = style({
  position: 'relative',
  margin: 'var(--margin)',
  width: '100%',
  gap: 'var(--gap)',
});

export const youtubeCard = style({
  border: 'none',
  borderRadius: 'var(--card-border-radius)',
  borderWidth: 'var(--card-border-width)',
  borderColor: 'var(--card-border-color)',
  borderStyle: 'var(--card-border-style)',
});

export const rssFeedModalDialogContent = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'stretch',
  maxHeight: '90vh',
  overflowY: 'scroll',
  '@media': {
    'only screen and (--mobile)': {
      width: '100%',
      height: 'auto',
      maxHeight: '90vh',
      overflowY: 'scroll',
    },
  },
});

export const rssFeedModalContentContainer = style({
  display: 'flex',
  margin: '0 auto',
  overflow: 'auto',
  position: 'relative',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  '@media': {
    'only screen and (--mobile)': {
      width: '100%',
      maxWidth: '100%',
      position: 'initial',
    },
  },
});

globalStyle(`${rssFeedModalContentContainer}::-webkit-scrollbar`, {
  display: 'none',
});

globalStyle(`${rssFeedModalDialogContent}::-webkit-scrollbar`, {
  display: 'none',
});

/* Carousel overrides start here */
globalStyle(`${rssFeedGrid} ${embla} .embla`, {
  vars: {
    '--slide-control-background-color': 'var(--post-slider-control-background-color)',
    '--slide-control-text-color': 'var(--post-slider-control-text-color)',
    '--slide-control-border-color': 'var(--post-slider-control-border-color)',
  },
  '@media': {
    '(min-width: 1024px)': {
      vars: {
        '--slide-size': 'var(--desktop-slide-size)',
      },
    },
    'only screen and (--mobile)': {
      vars: {
        '--slide-control-background-color':
          'var(--mobile-slider-control-background-color, var(--post-slider-control-background-color))',
        '--slide-control-text-color': 'var(--mobile-slider-control-text-color, var(--post-slider-control-text-color))',
        '--slide-control-border-color':
          'var(--mobile-slider-control-border-color, var(--post-slider-control-border-color))',
      },
    },
  },
});

globalStyle(`${rssFeedGrid} ${embla} .embla__viewport`, {
  paddingLeft: '0',
  paddingRight: '0',
  overflow: 'hidden',
});

globalStyle(`${rssFeedGrid} ${embla} .embla__container`, {
  margin: '0',
  gap: 'var(--gap)',
});

// Valid for elements rendered without card structure
globalStyle(`${rssFeedGrid} ${embla} .embla__slide`, {
  padding: 'var(--padding)',
});

// Valid for elements rendered with card structure as the padding is mapped
// to the first container of the card
globalStyle(`${rssFeedGrid} ${embla} .embla__slide.podcast-serializer-container`, {
  padding: 0,
});
/* Carousel overrides end here */
